import React, { useState, useEffect, useRef } from 'react';
import VersiWAP from '../../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo'
import { useSelector, useDispatch } from 'react-redux';
import { makeAjax, showMessage, url, respStatus, dotNumberValidation, dotNumberBlurValidation, withDotValidation } from '../../../../../helpers/global_helper';
import ConfirmBetDeskonPopup from '../../../../Popups/ConfirmBetDeskonPopup';
import BetSuccessPopup from '../../../../Popups/BetSuccessPopup';
import ErrorPopup from '../../../../Popups/ErrorPopup';
import ErrorInnerPopup from '../../../../Popups/ErrorInnerPopup';
import CancelledBetDeskonPopup from '../../../../Popups/CancelledBetDeskonPopup';
import { withTranslation } from "react-i18next";
import CommonBetHeader from '../../CommonBetHeader';
import { getUserBalance, setCommonConfig } from '../../../../../redux/actions';

const KepalaEkor = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [rowsToShow, setRowsToShow] = useState(5);

  const [tableData1, setTableData1] = useState(Array.from({ length: rowsToShow }, () => ({ Guess1: '', Guess2: '', Buy: '' })));
  const [totalBetAmount, setTotalBetAmount] = useState(0);
  const [prizeDiscount, setPrizeDiscount] = useState();

  const [allTableData, setAllTableData] = useState([]);
  const [combinedResults, setCombinedResults] = useState({
    gameId: null,
    gameType: 'kombinasi',
    dataangka: [],
    action: "process",
    betTogelAuth: "betTogelAuth"
  });
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [defaultValue, setDefaultvalue] = useState("");
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const belliRefs = useRef([[], [], []]);


  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameId, "gameType": combinedResults.gameType }).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      setPrizeDiscount(response.data.showDisc);
    })
  }, [gameId])

  useEffect(() => {
    calculateTotalBetAmount(); // Recalculate on initial render or any dependency changes
  }, [tableData1]);

  const calculateTotalBetAmount = () => {
    let total = 0;

    const discountFactor = 1 - (prizeDiscount / 100); // Use prizeDiscount for dynamic discount

    tableData1.forEach(row => {
      const buyValue = parseFloat(row.Buy) || 0; // Default to 0 if Buy is empty or invalid
      total += buyValue * betDiscount.showMultiple * discountFactor; // Apply dynamic discount and multiply by 1000
    });

    setTotalBetAmount(total); // Set the total bet amount
  };

  const handleInputFocus = (e, rowIndex, columnName, tableIndex) => {
    if (defaultValue !== '') {
      let value = defaultValue;
      let newData;
      let minValue = null;
      let maxValue = null;

      minValue = betDiscount.showMin / 1000;
      maxValue = betDiscount.showMax / 1000;
      if (columnName == 'Buy') {
        let regex = '';
        if (String(betDiscount.showMin).length === 3) {
          regex = /^\d*([.,]\d?)?$/;
        } else {
          regex = /^\d*$/;
          value = withDotValidation(value);
        }
        if (!regex.test(value)) {
          clearBetValue(rowIndex, tableIndex, columnName);
        }
        // else if (value < minValue && value) {
        //   setErrorMessage("Minimum bet is 1");
        //   setShowErrorPopup(true);
        //   clearBetValue(rowIndex, tableIndex, columnName);
        // } 
        else if (value > maxValue) {
          setErrorMessage("Your nominal bet exceeds the maximum limit.");
          setShowErrorPopup(true);
          clearBetValue(rowIndex, tableIndex, columnName);
        } else {
          switch (tableIndex) {
            case 0:
              newData = [...tableData1];
              newData[rowIndex][columnName] = value;
              setTableData1(newData);
              break;
            default:
              break;
          }
        }
      }
      else {
        switch (tableIndex) {
          case 0:
            newData = [...tableData1];
            newData[rowIndex][columnName] = value;
            setTableData1(newData);
            break;

          default:
            break;
        }
      }
    }
  }

  const handleInputBlur = (e, rowIndex, columnName, tableIndex) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange(e, rowIndex, columnName, tableIndex);
  }

  const handleInputChange = (e, rowIndex, columnName, tableIndex) => {
    let { value } = e.target;
    value = value.replace(',', '.');
    let newData;
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;

    if (columnName === 'Buy') {
      let regex = '';
      if (String(betDiscount.showMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
      if (!regex.test(value)) {
        clearBetValue(rowIndex, tableIndex, columnName);
      }
      // else if (value < minValue && value) {
      //   setErrorMessage("Minimum bet is 1");
      //   setShowErrorPopup(true);
      //   clearBetValue(rowIndex, tableIndex, columnName);
      // } 
      else if (value > maxValue) {
        setErrorMessage("Your nominal bet exceeds the maximum limit.");
        setShowErrorPopup(true);
        clearBetValue(rowIndex, tableIndex, columnName);
      } else if (tableIndex === 0) {
        // Update the data for tableIndex 0
        newData = [...tableData1];
        newData[rowIndex][columnName] = value;
        setTableData1(newData);
        calculateTotalBetAmount();
      }
    } else if (tableIndex === 0) {
      newData = [...tableData1];
      newData[rowIndex][columnName] = value;
      setTableData1(newData);
      calculateTotalBetAmount();

      const isGuess1Filled = newData[rowIndex].Guess1;
      const isGuess2Filled = newData[rowIndex].Guess2;

      if (isGuess1Filled && isGuess2Filled) {
        newData[rowIndex].Buy = defaultValue;
        setTableData1(newData);
        belliRefs.current[tableIndex][rowIndex].focus();
      }
    }
  }


  const clearBetValue = (rowIndex, tableIndex, columnName) => {
    let newData;
    if (belliRefs.current[tableIndex][rowIndex]) {
      belliRefs.current[tableIndex][rowIndex].value = '';
    }

    switch (tableIndex) {
      case 0:
        newData = [...tableData1];
        newData[rowIndex][columnName] = '';
        setTableData1(newData);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    const combinedData = [
      ...tableData1.map((row) => ({ ...row })),
    ];
    setAllTableData(combinedData);
  }, [tableData1]);

  useEffect(() => {
    const results = [];
    allTableData.forEach((row) => {
      if (row.Guess1 && row.Guess2 && row.Buy) {
        results.push([`${row.Guess1}-${row.Guess2}`, row.Buy * betDiscount.showMultiple, 'success']);
      }
    });
    setCombinedResults((prevState) => ({
      ...prevState,
      gameId: gameId,
      dataangka: results
    }));
  }, [allTableData]);


  useEffect(() => {

    resetAllData()

  }, [gameId])

  const resetAllData = () => {
    setTotalBetAmount(0)
    setTableData1(Array.from({ length: rowsToShow }, () => ({ Guess1: '', Guess2: '', Buy: '' })));
    setAllTableData([]);
    setCombinedResults({
      gameId: null,
      gameType: 'kombinasi',
      dataangka: [],
      action: "process",
      betTogelAuth: "betTogelAuth"
    });
    setErrorMessage('');
    setShowErrorPopup(false);
    setSubmitRespData([]);
    setSuccessPopup(false);
    setShowConfirmationPopup(false);
    setDefaultvalue("")
  };
  // const rowDataReset = (rowIndex) => {
  //   setTableData1(prevData => {
  //     const newData = [...prevData];
  //     newData[rowIndex] = { Guess1: '', Guess2: '', Buy: '' };
  //     return newData;
  //   });
  // };
  const processSubmit = () => {
    let valid = true;

    allTableData.forEach((row, index) => {
      // if ((row.Guess1 && !row.Guess2) || (!row.Guess1 && row.Guess2)) {
      //   setErrorMessage(`Please select both Guess1 and Guess2.`);
      //   setShowErrorPopup(true);
      //   valid = false;
      // } else if (row.Guess1 && row.Guess2 && !row.Buy) {
      //   setErrorMessage(`Buy amount is compulsory.`);
      //   setShowErrorPopup(true);
      //   valid = false;
      // }
    });

    if (combinedResults.dataangka.length === 0) {
      setErrorMessage('Please fill in at least one valid row.');
      setShowErrorPopup(true);
      valid = false;
    }

    if (valid) {
      setShowConfirmationPopup(true);
    }
  };

  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };

  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, combinedResults).then(response => {
      if (response.status !== respStatus['SUCCESS']) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      resetAllData();
      setSubmitRespData(prevData => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
    });
  };

  const handleDeafultInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (value > betDiscount.showMax / 1000) {
      setErrorMessage(props.t("you_have_reached_max_bet_value"));
      setShowErrorPopup(true);
      return;
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const handleDeafultInputBlur = (e) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true)
  }

  return (
    <>
      <div className='container'>
        <div>
          <CommonBetHeader gameName={"kombinasiMobile"} totalBetAmount={totalBetAmount} rowsToShow={null} />
        </div>
        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th>{props.t("guess")} AS</th>
              <th>{props.t("guess")} EKOR</th>
              <th className="d-flex align-right">
                <input
                  type="text"
                  autoComplete="off"
                  placeholder="Auto Bet"
                  value={defaultValue ? defaultValue : ''}
                  onChange={handleDeafultInputChange}
                  onBlur={handleDeafultInputBlur}
                  inputMode="decimal"
                  pattern="[0-9]*[.,]?[0-9]**"
                />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {[...Array(rowsToShow)].map((_, index) => (
              <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                <td>{index + 1}</td>
                <td className="inputs">
                  <select style={{ minWidth: 90 }}
                    value={tableData1[index].Guess1}
                    name={`kepala-${index}`}
                    onChange={(e) => handleInputChange(e, index, 'Guess1', 0)}
                  >
                    <option ></option>
                    <option value="Kepala_Ganjil">
                      Kepala {props.t("odd")}
                    </option>
                    <option value="Kepala_Genap">
                      Kepala {props.t("even")}
                    </option>
                    <option value="Kepala_Besar">
                      Kepala {props.t("big")}
                    </option>
                    <option value="Kepala_Kecil">
                      Kepala {props.t("small")}
                    </option>
                  </select>
                </td>
                <td className="inputs">
                  <select style={{ minWidth: 90 }}
                    value={tableData1[index].Guess2}
                    name={`ekor-${index}`}
                    onChange={(e) => handleInputChange(e, index, 'Guess2', 0)}
                  >
                    <option ></option>
                    <option value="Ekor_Ganjil">
                      Ekor {props.t("odd")}
                    </option>
                    <option value="Ekor_Genap">
                      Ekor {props.t("even")}
                    </option>
                    <option value="Ekor_Besar">
                      Ekor {props.t("big")}
                    </option>
                    <option value="Ekor_Kecil">
                      Ekor {props.t("small")}
                    </option>
                  </select>
                </td>
                <td><input type='text' placeholder='Bet'
                  name={`belli-${index}`}
                  value={tableData1[index].Buy}
                  inputMode="decimal"
                  pattern="[0-9]*[.,]?[0-9]**"
                  onChange={(e) => handleInputChange(e, index, 'Buy', 0)}
                  onFocus={(e) => handleInputFocus(e, index, 'Buy', 0)}
                  onBlur={(e) => handleInputBlur(e, index, 'Buy', 0)}
                  disabled={!tableData1[index].Guess1 || !tableData1[index].Guess2}
                  ref={el => belliRefs.current[0][index] = el}
                /></td>
                {/* <td><button
                  onClick={(e) => rowDataReset(index)} tabindex="-1"
                  className='reset-button'>reset</button></td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="last_div">
        <div className="left_div">
          <p>Menebak kombinasi ganjil/genap dan besar/kecil pada posisi tertentu</p>
        </div>
        <div className="right_div">
          <ul className="button-list">
            <li>
              <button className="reset" onClick={resetAllData}>
                {props.t('reset')}
              </button>
            </li>
            <li>
              <button className="submit" onClick={processSubmit}>
                {props.t('submit')}
              </button>
            </li>
          </ul>
        </div>
      </div>

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose} submitProcessOk={submitProcessOk}

        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup
          onClose={() => setShowCanclledPopup(false)}

        />
      )}
      {successPopup && (
        <div className="popup-overlay">
          <BetSuccessPopup response={SubmitRespData} onClose={() => setSuccessPopup(false)} />
        </div>
      )}
      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup message={errMessage} onClose={() => setShowErrorPopup(false)} />
        </ErrorInnerPopup>
      )}
    </>
  )
}

export default withTranslation()(KepalaEkor)